<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Zahlungsart bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.payment-methods.update', paymentMethod))">
                <form-fields :form="form" :payment-method="paymentMethod" :tax-calc-mode-options="taxCalcModeOptions" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'paymentMethod',
            'taxCalcModeOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: this.paymentMethod.name,
                    description: this.paymentMethod.description,
                    sort_order: this.paymentMethod.sort_order,
                    enabled: this.paymentMethod.enabled,
                    notes: this.paymentMethod.notes,
                    options: this.paymentMethod.options,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>